// ABOUTME: Shared query hook for the user's watchlists under the ['watchlists'] key.
// ABOUTME: One staleTime'd source so every consumer dedupes instead of refetching per navigation.

import type { WatchlistWithItems } from '@alpha-finder/contracts/watchlist';
import { useQuery } from '@tanstack/react-query';
import { watchlistApi } from '../lib/api-client';

export const WATCHLISTS_QUERY_KEY = ['watchlists'] as const;

// Watchlists change rarely and are read on many pages; 60s keeps them shared
// across navigation without a background refetch on every remount.
export const WATCHLISTS_STALE_TIME = 60_000;

export function useWatchlists(options?: { enabled?: boolean }) {
  return useQuery<WatchlistWithItems[]>({
    queryKey: WATCHLISTS_QUERY_KEY,
    queryFn: () => watchlistApi.list(),
    staleTime: WATCHLISTS_STALE_TIME,
    enabled: options?.enabled,
  });
}
